/**
 * Modello per i dati GeoJSON dei confini dei comuni
 */

// Proprietà di ogni feature (comune)
export interface ComuneProperties {
  id: number;
  denominazione: string;
  codiceCatastale: string;
  statoRichiesta: string;
}

// Coordinate del poligono - Array multidimensionale di coordinate [lng, lat]
export type Coordinate = number[];
export type LineString = Coordinate[];
export type Polygon = LineString[];
export type MultiPolygon = Polygon[];

// Geometria del comune - può essere sia singolo poligono che multi-poligono
export interface ComuneGeometry {
  type: 'Polygon' | 'MultiPolygon';
  coordinates: Polygon | MultiPolygon;
}

// Singola feature che rappresenta un comune
export interface ComuneFeature {
  type: 'Feature';
  properties: ComuneProperties;
  geometry: ComuneGeometry;
}

// Collezione di feature (comuni)
export interface ComuniFeatureCollection {
  type: 'FeatureCollection';
  features: ComuneFeature[];
}

// Risposta del servizio getConfiniComuni
export interface ConfiniComuniResponse {
  features: ComuneFeature[];
}

/**
 * Classe di utilità per lavorare con i dati GeoJSON dei comuni
 */
export class ComuneGeoJsonUtils {
  /**
   * Converte la risposta del servizio in una FeatureCollection GeoJSON standard
   */
  static toFeatureCollection(response: ConfiniComuniResponse): ComuniFeatureCollection {
    return {
      type: 'FeatureCollection',
      features: response.features.map(feature => ({
        ...feature,
        type: 'Feature'
      }))
    };
  }

  /**
   * Ottiene il centro di un comune (punto centrale approssimativo)
   * Nota: questo è un calcolo semplificato, non il centroide geometrico esatto
   */
  static getCentroComune(feature: ComuneFeature): [number, number] {
    try {
      // Estrai il primo set di coordinate disponibile
      let coords: number[][] = [];

      if (feature.geometry.type === 'Polygon') {
        coords = feature.geometry.coordinates[0] as number[][];
      } else if (feature.geometry.type === 'MultiPolygon') {
        coords = (feature.geometry.coordinates[0][0]) as number[][];
      }

      // Calcola la media delle coordinate
      let sumLng = 0, sumLat = 0;
      for (const coord of coords) {
        sumLng += coord[0];
        sumLat += coord[1];
      }

      return [
        sumLng / coords.length,
        sumLat / coords.length
      ];
    } catch (e) {
      console.error('Errore nel calcolo del centro del comune', e);
      return [0, 0]; // Fallback
    }
  }
}
